module.exports = __webpack_public_path__ + "static/7-ddf3b70902873494d637d0eb9fe68b95.jpg";